/**
 * "Count per status" texts — the STATUS_COUNTS API (one count per value of a
 * group-by column). Its own file so the runtime and the data service can both
 * use it without importing each other.
 */

/** Text-only Summary choice: one value of the STATUS_COUNTS API (see TextDataBinding.statusValue). */
export const STATUS_COUNT_AGGREGATION = 'STATUS_COUNT';

/** The count for `status` out of a STATUS_COUNTS answer; case / spaces / "_" ignored ("Not Planned" = not_planned). */
export function statusCountOf(counts: Record<string, number> | undefined, status: string | undefined): number | null {
  if (!counts || !status) return null;
  const key = (text: string) => text.toLowerCase().replace(/[^a-z0-9]/g, '');
  const hit = Object.entries(counts).find(([name]) => key(name) === key(status));
  // A status with no rows is simply absent from the answer: it counts 0.
  return hit ? hit[1] : 0;
}
